import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { Box } from '@mui/material';
import { MAX_FUTURE_MONTHS } from '../../constants/search';
import './DatePicker.css';

// Component for selecting travel dates with custom styling and behavior
function TravelDatePicker({ value, onChange }) {
  // Calculate date constraints
  const tomorrow = dayjs().add(1, 'day'); // Minimum selectable date
  const maxDate = dayjs().add(MAX_FUTURE_MONTHS, 'month'); // Maximum selectable date
  const dateValue = value ? dayjs(value) : null; // Convert string date to dayjs object

  // Set default value to tomorrow if no date is selected
  React.useEffect(() => {
    if (!value) {
      onChange(tomorrow.format('YYYY-MM-DD'));
    }
  }, [value, onChange, tomorrow]);

  // Handle date selection changes
  const handleChange = (newValue) => {
    onChange(newValue ? newValue.format('YYYY-MM-DD') : null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ width: '100%' }}>
        <DatePicker
          value={dateValue}
          onChange={handleChange}
          minDate={tomorrow}
          maxDate={maxDate}
          format="DD/MM/YYYY"
          closeOnSelect={true}
          // Remove default calendar icon
          slots={{
            openPickerIcon: () => null
          }}
          slotProps={{
            // Configure text field appearance and behavior
            textField: {
              fullWidth: true,
              className: 'date-picker-input',
              // Add custom calendar icon
              InputProps: {
                startAdornment: <span className="material-icons">calendar_today</span>
              },
              // Make input read-only to prevent manual editing
              inputProps: {
                readOnly: true,
                placeholder: 'Select date'
              },
              // Open calendar on click anywhere in the input
              onMouseDown: (e) => {
                e.preventDefault();
                const buttonElement = e.currentTarget.querySelector('button');
                if (buttonElement) {
                  buttonElement.click();
                }
              },
              // Prevent keyboard input
              onKeyDown: (e) => {
                e.preventDefault();
                return false;
              }
            },
            // Make field read-only
            field: {
              readOnly: true
            },
            // Restrict keyboard input in calendar popup
            desktopPaper: {
              onKeyDown: (e) => {
                // Only allow navigation and selection keys
                if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', 'Escape'].includes(e.key)) {
                  e.preventDefault();
                  return false;
                }
              }
            }
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default TravelDatePicker;